<template>
  <div>
    <b-form-group id="input-group-10" label="Responsable" label-for="input-10">
      <b-form-select
        @change="listMotiveResponsible"
        id="input-10"
        v-model="selectedResponsible"
        :options="filteredResponsibles"
        required
      >
        <b-form-select-option :value="null"
          >Seleccione una opción
        </b-form-select-option>
      </b-form-select>
    </b-form-group>
    <template v-if="selectedResponsible">
      <b-row>
        <b-col cols="12">
          <b-form-group id="input-group-11" label="Motivo" label-for="input-11">
            <b-form-select
              id="input-11"
              v-model="motiveSelected"
              :options="motivesResponsibles"
              required
            >
              <b-form-select-option :value="null"
                >Seleccione una opción
              </b-form-select-option>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group
            id="input-group-12"
            label="Observaciones"
            label-for="input-12"
          >
            <b-form-input
              id="input-12"
              v-model="form.observation"
              placeholder="Ingrese aquí sus observaciones"
              required
            ></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="6">
          <label>Fecha Estimada</label>
          <calendar v-model="form.estimatedDate" />
        </b-col>
        <b-col cols="6">
          <label>Turno</label>
          <b-form-select
            v-model="turnSelected"
            :options="turn"
            required
          ></b-form-select>
        </b-col>
      </b-row>
      <!-- responsable 1 cliente -->
      <template v-if="selectedResponsible == 1">
        <b-row class="padding-two-top">
          <b-col cols="12">
            <b-form-group v-slot="{ ariaDescribedby }">
              <b-form-radio-group
                @change="clearValues"
                v-model="selectedOptionPayment"
                :options="options"
                :aria-describedby="ariaDescribedby"
                name="plain-inline"
                plain
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <template v-if="selectedOptionPayment === 'A'">
          <b-row>
            <b-col cols="12">
              <label class="text-grey">Tipo de documento</label>
              <b-form-group>
                <b-form-select
                  @change="clearValues"
                  v-model="selectedOptionDoc"
                  size="md"
                  :options="optionsDocuments"
                ></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>
          <template v-if="selectedOptionDoc === 'A'">
            <b-row>
              <b-col cols="6">
                <label class="text-grey">Tienda</label>
                <b-form-group>
                  <b-form-select
                    v-model="selectedStore"
                    size="md"
                    :options="optionStores"
                  >
                    <template #first>
                      <b-form-select-option :value="null" :disabled="true"
                        >Elige una sucursal</b-form-select-option
                      >
                    </template>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="6">
                <label class="text-grey">Fecha</label>
                <b-form-input
                  v-model="paymentValidate.date"
                  type="date"
                ></b-form-input>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="4" md="4">
                <label>Secuencia</label>
                <b-form-input
                  v-model="paymentValidate.sequence"
                  placeholder="Escriba aquí"
                  type="text"
                ></b-form-input>
              </b-col>
              <b-col cols="12" sm="4" md="4">
                <label>N° caja</label>
                <b-form-input
                  v-model="paymentValidate.caja"
                  type="text"
                  placeholder="Escriba aquí"
                ></b-form-input>
              </b-col>
              <b-col cols="12" sm="4" md="4">
                <b-button
                  @click="searchVouchers"
                  class="rounded-button border-none"
                >
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="12">
                <template>
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="danger"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                  >
                    <p>
                      {{ messageAlert }}
                    </p>
                    <b-progress
                      variant="warning"
                      :max="dismissSecs"
                      :value="dismissCountDown"
                      height="4px"
                    ></b-progress>
                  </b-alert>
                </template>
                <div v-if="vouchers.details.length > 0">
                  <b-table
                    :items="vouchers.details"
                    :fields="fieldsVoucher"
                    :tbody-tr-class="rowClass"
                  ></b-table>
                </div>
              </b-col>
            </b-row>
          </template>
          <template v-else-if="selectedOptionDoc === 'B'">
            <b-row>
              <b-col cols="4">
                <label>Nota de venta</label>
                <b-form-input
                  v-model="paymentValidate.nv"
                  type="text"
                  placeholder="Escriba aquí"
                ></b-form-input>
              </b-col>
              <b-col sm="8">
                <b-button
                  @click="searchBySellerNote"
                  class="rounded-button border-none"
                >
                  <font-awesome-icon icon="search" />
                </b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <template>
                  <b-alert
                    :show="dismissCountDown"
                    dismissible
                    variant="warning"
                    @dismissed="dismissCountDown = 0"
                    @dismiss-count-down="countDownChanged"
                  >
                    <p>
                      {{ messageAlert }}
                    </p>
                    <b-progress
                      variant="warning"
                      :max="dismissSecs"
                      :value="dismissCountDown"
                      height="4px"
                    ></b-progress>
                  </b-alert>
                </template>
                <div v-if="dataNV.length">
                  <b-table
                    show-empty
                    :busy="isBusy"
                    class="tab-b"
                    :items="dataNV"
                    :fields="fields"
                    responsive="sm"
                  >
                    <template #table-busy>
                      <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                      </div>
                    </template>
                  </b-table>
                </div>
              </b-col>
            </b-row>
          </template>
          <b-row>
            <b-col cols="12" class="text-center padding-two-top">
              <b-button
                :disabled="isEnabledButtonReprogramar"
                @click="reprogramarOS"
                class="btn-orange"
              >
                <font-awesome-icon icon="check-circle" /> Reprogramar
              </b-button>
            </b-col>
          </b-row>
        </template>
        <template v-else-if="selectedOptionPayment === 'B'">
          <b-row>
            <b-col cols="12">
              <span>
                Al exonerar el pago un usuario supervisor deberá aprobar la
                reprogramación para que se haga efectivo.
              </span>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12" class="text-center padding-two-top">
              <b-button
                :disabled="checkIsEnabled"
                @click="reprogramarOS"
                class="btn-orange"
              >
                <font-awesome-icon icon="check-circle" /> Reprogramar
              </b-button>
            </b-col>
          </b-row>
        </template>
      </template>
      <template v-else>
        <b-row>
          <b-col cols="12" class="text-center padding-two-top">
            <b-button
              :disabled="checkIsEnabled"
              @click="reprogramarOS"
              class="btn-orange"
            >
              <font-awesome-icon icon="check-circle" /> Reprogramar
            </b-button>
          </b-col>
        </b-row>
      </template>
    </template>
    <div></div>
  </div>
</template>
<script>
import axios from "axios";
import { mapState } from "vuex";
import Calendar from "./Calendar.vue";
import {getStores} from '../../assets/js/common'
export default {
  components: { Calendar },
  name: "ReprogramarOs",
  props: ["detailId"],
  data() {
    return {
      fieldsVoucher: ["sku", "quantity"],
      estimatedDate: "",
      turnSelected: null,
      form: { estimatedDate: "", observation: "" },
      vouchers: { details: [] },
      selectedOptionPayment: "",
      motiveSelected: null,
      motivesResponsibles: [],
      responsibles: [],
      selectedResponsible: null,
      options: [
        { text: "Validar pago", value: "A" },
        { text: "Exonerar pago", value: "B" },
      ],
      optionsDocuments: [
        { value: "A", text: "Comprobante de pago" },
        { value: "B", text: "Nota de venta" },
      ],
      selectedOptionDoc: "A",
      selectedStore: null,
      paymentValidate: {
        date: "",
        caja: null,
        nv: "",
        sequence: null,
      },
      optionStores: [],
      turn: [
        { value: "MORNING", text: "Mañana" },
        { value: "ALL_DAY", text: "Todo el día" },
        { value: "AFTERNOON", text: "Tarde" },
      ],
      valuesResponseReprog: { show: true, message: "", hasError: false },
      dataNV: [{ state: "" }],
      isBusy: false,
      optionsSellerNote: [],
      fields: [
        { key: "skuService", label: "SKU Servicio" },
        { key: "descriptionSku", label: "Descripción" },
        { key: "quantity", label: "Cantidad" },
        { key: "state", label: "Estado" },
      ],
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      messageAlert: "",
    };
  },
  computed: {
    checkIsEnabled() {
      if (this.form.estimatedDate && this.turnSelected && this.motiveSelected)
        return false;
      else return true;
    },
    isEnabledButtonReprogramar() {
      if (this.vouchers.details.length) {
        return false;
      } else if (this.dataNV.length) {
        if (this.dataNV[0].state === "PAGADO") return false;
        else return false;
      } else return true;
    },
    filteredResponsibles() {
      return this.responsibles.filter((entry) => {
        return (
          entry.value != 5 &&
          entry.value != 6 &&
          entry.value != 8 &&
          entry.value != 9 &&
          entry.value != 10 &&
          entry.value != 11 &&
          entry.value != 13 &&
          entry.value != 12
        );
      });
    },
    ...mapState("module", ["username","token"]),
  },
  created() {
    this.listResponsible();
    this.getStoresCombo();
  },
  methods: {
    changeDate(selected) {
      this.form.estimatedDate = selected;
    },

    async getStoresCombo() {
      try {
        let data=await getStores();
        this.optionStores = data;
      } catch (error) {
        console.error(error);
      }
    },
    async searchVouchers() {
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_PAYMENT_REF +
            "/voucher-ref?Date=" +
            this.paymentValidate.date +
            "&Pos=" +
            this.paymentValidate.caja +
            "&Sequence=" +
            this.paymentValidate.sequence +
            "&Store=" +
            this.selectedStore,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        let hasSkuRepro = response.data.details.some((b) => b.sku === "27347");
        
        if (!hasSkuRepro) {
          this.messageAlert =
            "El comprobante de pago no tiene asociado el servicio de reprogramación";
          this.showAlert();
          return;
        }
        this.vouchers = response.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listResponsible() {
      try {
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE + "/responsibles?limit=50&page=1"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.responsible,
          };
        });
        this.responsibles = data;
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },
    async reprogramarOS() {
      try {
        this.$store.commit("SET_LOADING", true);
        let validatePayment = this.selectedOptionPayment == "A" ? true : false;
        await axios.post(
          process.env.VUE_APP_ORDER_BUSINESS_BASE + "/reschedulings",
          {
            childId: this.detailId,
            user: this.username,
            date: this.form.estimatedDate,
            turn: this.turnSelected,
            motiveId: this.motiveSelected,
            observations: this.form.observation,
            validatePayment: validatePayment,
            sequence: this.paymentValidate.sequence,
            store: this.selectedStore,
            pos: this.paymentValidate.caja,
            voucherDate: this.paymentValidate.date,
            sellerNote: this.paymentValidate.nv
          }, // the data to post
          {
            headers: {
              "Content-type": "application/json",
              client_id: process.env.VUE_APP_CLIENT_ID_REPRO,
              access_token: process.env.VUE_APP_ACCESS_TOKEN_REPRO,
            },
          }
        );

        this.valuesResponseReprog.message = "Reprogramación exitosa";
      } catch (error) {
        console.log(error);
        this.valuesResponseReprog.hasError = true;
        this.valuesResponseReprog.message = error.response.data.message;
      } finally {
        this.$bvModal.hide("modal-reprogramar");
        this.$emit("setResponse", this.valuesResponseReprog);
        this.$store.commit("SET_LOADING", false);
      }
    },
    async listMotiveResponsible() {
      if (this.motiveSelected) this.motiveSelected = null;
      this.selectedOptionPayment = "";
      try {
        this.$store.commit("SET_LOADING", true);
        let response = await axios.get(
          process.env.VUE_APP_ORDERS_CORE_BASE +
            "/responsibles/" +
            this.selectedResponsible +
            "/motives"
        );
        const data = response.data.map((row) => {
          return {
            value: row.id,
            text: row.description,
          };
        });
        this.motivesResponsibles = data;
        console.log(response);
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    async searchBySellerNote() {
      try {
        this.$store.commit("SET_LOADING", true);
        this.isBusy = true;
        let response = await axios.get(
          process.env.VUE_APP_SELLERNOTE_REF +
            "?sellerNote=" +
            this.paymentValidate.nv,
            {
              headers: {
                  "Content-type": "application/json",
                  "Authorization": "Bearer "+ this.token
                }
            }
        );
        if (
          response.data.status != "PAYED" &&
          response.data.status != "DELIVERED"
        ) {
          this.messageAlert = "El estado de la nota de venta deber ser pagado.";
          this.showAlert();
          return;
        }
        console.log(response)
        let hasSkuRepro = response.data.details.some((b) => b.serviceSku === "27347");
        console.log(hasSkuRepro)
        if (!hasSkuRepro) {
          this.messageAlert =
            "La nota de venta no tiene asociado el servicio de reprogramación";
          this.showAlert();
          return;
        }
        let filterData = response.data.details.filter(
          (item) => !!item.serviceSku
        );

        const data = filterData.map((row) => {
          return {
            descriptionSku: row.serviceSku ? row.description : "",
            skuService: row.serviceSku ? row.serviceSku : "",
            skuProduct: "",
            descriptionSkuProduct: "",
            quantity: row.quantity,
            state: this.translateState(response.data.status),
          };
        });
        this.dataNV = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.commit("SET_LOADING", false);
        this.isBusy = false;
      }
    },
    checkIfProducExist(item) {
      if (item && item.products.length) return true;
      return false;
    },
    translateState(value) {
      switch (value) {
        case "PAYMENT_PENDING":
          return "PENDIENTE_PAGO";
        case "PAYED":
          return "PAGADO";
        case "CANCELLED_NOT_PAYED":
          return "CANCELADO";
        case "DELIVERED":
          return "PAGADO";
        default:
          return "-";
      }
    },
    clearValues() {
      if (this.dataNV.length) this.dataNV = [];
      if (this.paymentValidate.nv) this.paymentValidate.nv = null;
      if (this.paymentValidate.caja) this.paymentValidate.caja = null;
      if (this.paymentValidate.sequence) this.paymentValidate.sequence = null;
      if (this.selectedStore) this.selectedStore = null;
      if (this.paymentValidate.date) this.paymentValidate.date = null;
      if (this.vouchers.length) this.vouchers = { details: [] };
      if (this.messageAlert.length) this.messageAlert = "";
    },
  },
};
</script>
<style scoped></style>
